<template>
  <div class="home">
    <img class="bg-img" src="../assets/home/bg.png" alt="" />
    <HomeHeader style="margin-bottom: 29px"></HomeHeader>
    <div class="tabs" :class="{ fix: scrollFlag }">
      <ul>
        <li @click="toHomeType('index')" :class="{ li: urlName === 'index' }">
          首页
        </li>
        <li
          @click="toHomeType('macroscopic')"
          :class="{ li: urlName === 'macroscopic' }"
        >
          宏观
        </li>
        <li @click="toHomeType('coke')" :class="{ li: urlName === 'coke' }">
          焦炭
        </li>
        <li
          @click="showSteelFnc"
          :class="{ li: urlName === 'steel' || urlName === 'ironstone' }"
        >
          钢铁
          <el-collapse-transition>
            <div v-show="showSteel" class="select-content">
              <div class="transition-box" @click="toHomeType('steel')">
                钢铁
              </div>
              <div class="transition-box" @click="toHomeType('ironstone')">
                铁矿石
              </div>
            </div>
          </el-collapse-transition>
        </li>
        <li
          @click="shows($event)"
          :class="{ li: urlName === 'coal' || urlName === 'powerCoal' }"
          class="father"
        >
          煤炭
          <el-collapse-transition>
            <div v-show="show" class="select-content">
              <div class="transition-box" @click="toHomeType('coal')">焦煤</div>
              <div class="transition-box" @click="toHomeType('powerCoal')">
                动力煤
              </div>
            </div>
          </el-collapse-transition>
        </li>
        <li
          @click="showAromaticFnc"
          :class="{
            li:
              urlName === 'oilBenzene' ||
              urlName === 'cokeBenzene' ||
              urlName === 'caprolactam' ||
              urlName === 'adipic' ||
              urlName === 'styrene',
          }"
        >
          芳烃
          <el-collapse-transition>
            <div v-show="showAromatic" class="select-content">
              <div class="transition-box" @click="toHomeType('oilBenzene')">
                石油苯
              </div>
              <div class="transition-box" @click="toHomeType('cokeBenzene')">
                焦化苯
              </div>
              <div class="transition-box" @click="toHomeType('styrene')">
                苯乙烯
              </div>
              <div class="transition-box" @click="toHomeType('caprolactam')">
                己内酰胺
              </div>
              <div class="transition-box" @click="toHomeType('adipic')">
                己二酸
              </div>
            </div>
          </el-collapse-transition>
        </li>
        <li @click="showMethanolFnc" :class="{ li: urlName === 'methanol' }">
          醇氨
          <el-collapse-transition>
            <div v-show="showMethanol" class="select-content">
              <div class="transition-box" @click="toHomeType('methanol')">
                甲醇
              </div>
            </div>
          </el-collapse-transition>
        </li>
        <li
          @click="showCarbonFnc"
          :class="{
            li:
              urlName === 'zetar' ||
              urlName === 'anhydride' ||
              urlName === 'asphalt' ||
              urlName === 'needle',
          }"
        >
          碳材料
          <el-collapse-transition>
            <div v-show="showCarbon" class="select-content">
              <div class="transition-box" @click="toHomeType('zetar')">
                煤焦油加工
              </div>
              <div class="transition-box" @click="toHomeType('asphalt')">
                煤沥青
              </div>
              <div class="transition-box" @click="toHomeType('needle')">
                针状焦
              </div>
              <div class="transition-box" @click="toHomeType('anhydride')">
                苯酐
              </div>
            </div>
          </el-collapse-transition>
        </li>
        <li
          @click="showOilFnc"
          :class="{ li: urlName === 'petroleum' || urlName === 'hydrogen' }"
        >
          其他化工
          <el-collapse-transition>
            <div v-show="showOil" class="select-content">
              <div class="transition-box" @click="toHomeType('petroleum')">
                石油
              </div>
              <div class="transition-box" @click="toHomeType('hydrogen')">
                氢能
              </div>
            </div>
          </el-collapse-transition>
        </li>
        <li
          @click="toHomeType('dataCenter')"
          :class="{ li: urlName === 'dataCenter' }"
        >
          数据指标
        </li>
      </ul>
    </div>
    <div class="float_right">
      <p class="icon_float">
        <img
          @click="showFloat = false"
          v-show="showFloat"
          src="@/assets/images/float_l.png"
        />
        <img
          @click="showFloat = true"
          v-show="!showFloat"
          src="@/assets/images/float_r.png"
        />
      </p>
      <transition name="slide-fade" v-if="showFloat">
        <div>
          <div class="discussLogo" @click.stop="openPermissions">
            <img src="../assets/home/permissions.png" alt="" />
            <p>权限申请</p>
            <transition name="fade">
              <div class="permissions" v-if="permissionsFlag" @click.stop>
                <div class="permissions_top">
                  <p>权限申请</p>
                  <p
                    class="el-icon-close close"
                    @click.stop="openPermissions"
                  ></p>
                </div>
                <div class="permissions_main">
                  <p>申请流程：</p>
                  <p class="bot">
                    OA->集团管控流程->IT管控运维管控->IT账号新增
                  </p>
                  <p class="bot">联系人：付书研</p>
                  <p>电话：19801156960</p>
                </div>
              </div>
            </transition>
          </div>
          <div class="discussLogo" @click="openDiscuss">
            <img src="../assets/home/discussLogo.png" alt="" />
            <p>交流讨论</p>
          </div>
        </div>
      </transition>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="收货地址"
      width="980px"
      :visible.sync="discussFlag"
    >
      <div class="head" slot="title">
        <p>{{ title }}</p>
        <img
          src="../assets/images/waiconfirm.png"
          @click="discussFlag = false"
          alt=""
        />
      </div>
      <Discuss v-on:closeCh="closeFn" :sourceType="sourceType"></Discuss>
    </el-dialog>
    <router-view
      :class="{ marginTop: scrollFlag }"
      style="margin-top: 24px"
    ></router-view>
  </div>
</template>

<script>
import HomeHeader from "@/components/common/Header";
import Discuss from "@/components/common/discuss";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Home",
  components: { HomeHeader, Discuss },
  data() {
    return {
      scrollFlag: false,
      discussFlag: false,
      show: false,
      logoFlag: false,
      showSteel: false,
      showOil: false,
      showAromatic: false,
      showCarbon: false,
      showMethanol: false,
      title: "",
      sourceType: "",
      url: 0,
      permissionsFlag: false,
      showFloat: true,
    };
  },
  computed: {
    ...mapGetters(["urlName"]),
  },
  created() {
    this.url = window.location.pathname.split("/").indexOf("map");
    this.GetUrlName().then((res) => {
      this.sourceType = res.sourceType;
      this.title = res.title + "讨论区";
    });
    this.judgeLogoFlag();
  },
  activated() {
    this.GetUrlName().then((res) => {
      this.sourceType = res.sourceType;
      this.title = res.title + "讨论区";
    });
    this.judgeLogoFlag();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("click", this.closeFloat);
    document.body.addEventListener(
      "click",
      (e) => {
        this.show = e.target.parentNode.className === 'father"';
        this.showSteel = false;
        this.showOil = false;
        this.showAromatic = false;
        this.showCarbon = false;
        this.showMethanol = false;
      },
      false
    );
  },
  methods: {
    ...mapMutations(["SET_URL_NAME"]),
    ...mapActions(["GetUrlName"]),
    openPermissions() {
      this.permissionsFlag = !this.permissionsFlag;
    },
    closeFloat() {
      this.permissionsFlag = false;
    },
    /**
     * 判断是否展示讨论区logo
     */
    judgeLogoFlag() {
      let url = window.location.pathname.split("/").indexOf("map");
      this.logoFlag = !(
        this.urlName === "macroscopic" ||
        this.urlName === "index" ||
        this.urlName === "dataCenter" ||
        url === 2
      );
    },
    closeFn(val) {
      this.discussFlag = val;
    },
    /**
     * 切换tabs
     * @param url
     */
    toHomeType(url) {
      this.SET_URL_NAME(url);
      this.$router.push({ path: `/${url}` });
      this.show = false;
    },
    shows(ev) {
      ev.stopPropagation();
      this.show = !this.show;
      this.showSteel = false;
      this.showAromatic = false;
      this.showOil = false;
      this.showCarbon = false;
      this.showMethanol = false;
      // this.urlName = 'coal';
    },
    showSteelFnc(e) {
      e.stopPropagation();
      this.showSteel = !this.showSteel;
      this.show = false;
      this.showAromatic = false;
      this.showOil = false;
      this.showCarbon = false;
      this.showMethanol = false;
    },
    showOilFnc(e) {
      e.stopPropagation();
      this.showOil = !this.showOil;
      this.showSteel = false;
      this.show = false;
      this.showAromatic = false;
      this.showCarbon = false;
      this.showMethanol = false;
    },
    showAromaticFnc(e) {
      e.stopPropagation();
      this.showAromatic = !this.showAromatic;
      this.showOil = false;
      this.showSteel = false;
      this.show = false;
      this.showCarbon = false;
      this.showMethanol = false;
    },
    showCarbonFnc(e) {
      e.stopPropagation();
      this.showCarbon = !this.showCarbon;
      this.showAromatic = false;
      this.showOil = false;
      this.showSteel = false;
      this.show = false;
      this.showMethanol = false;
    },
    showMethanolFnc(e) {
      e.stopPropagation();
      this.showMethanol = !this.showMethanol;
      this.showCarbon = false;
      this.showAromatic = false;
      this.showOil = false;
      this.showSteel = false;
      this.show = false;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 118) {
        this.scrollFlag = true;
      } else {
        this.scrollFlag = false;
      }
    },
    /**
     * 打开讨论区
     */
    openDiscuss() {
      this.discussFlag = true;
      this.closeFloat();
    },
  },
};
</script>

<style scoped lang="less">
.fix {
  position: fixed;
  top: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0; /*透明度*/
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.marginTop {
  padding-top: 68px !important;
}

.home {
  //padding-bottom: 50px;

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
  }

  .tabs {
    z-index: 998;
    width: 100%;
    height: 48px;
    background: #d3131a;
    text-align: center;

    ul {
      width: 1200px;
      margin: 0 auto;
      position: relative;

      li {
        float: left;
        width: 120px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: #fff;
        cursor: pointer;
        font-size: 16px;
        position: relative;
      }

      .select-content {
        position: absolute;
        z-index: 1998;
        width: 120px;
        background: #ffffff;
        box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
        border-radius: 4px;

        .transition-box {
          height: 47px;
          line-height: 47px;
          text-align: center;
          cursor: pointer;
          color: #222;
          font-size: 13px;

          span {
            width: 6px;
            height: 6px;
            background: #d3131a;
            border-radius: 1px;
            display: inline-block;
            margin-right: 5px;
            vertical-align: middle;
          }
        }

        .transition-box:hover {
          color: #d3131a;
        }
      }

      li:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }
  .float_right {
    z-index: 999;
    position: fixed;
    z-index: 99999;
    right: 4px;
    bottom: 20px;
    height: 210px;
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
      transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
      transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade-enter,
    .slide-fade-leave-to {
      // transform: translateX(10px);
      opacity: 0;
    }
    .icon_float {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 6px;
      img {
        width: 34px;
        height: auto;
        cursor: pointer;
      }
    }
    .discussLogo {
      width: 72px;
      height: 79px;
      background: #f8f8f8;
      box-shadow: 0px 0px 4px 0px rgb(0 0 0 / 20%);
      border-radius: 8px 0px 8px 8px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 10px;
      position: relative;
      > img {
        width: 28px;
        margin-top: 14px;
      }
      > p {
        color: #d3131a;
        font-size: 13px;
      }
      .permissions {
        z-index: 999999;
        background: #ffffff;
        position: absolute;
        left: -390px;
        top: -50px;
        height: 220px;
        width: 380px;
        box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
        border-radius: 2px 2px 0px 0px;
        cursor: default;
        .permissions_top {
          padding: 0 20px;
          height: 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: linear-gradient(0deg, #a60505 0%, #eb2b38 100%);
          p {
            line-height: 25px;
            color: #ffffff;
            font-weight: 500;
            font-size: 18px;
          }
          .close {
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            width: 30px;
            cursor: pointer;
          }
        }
        .permissions_main {
          padding: 23px 20px 20px;
          font-size: 14px;
          font-weight: 500;
          color: #222222;
          line-height: 20px;
          text-align: left;
          .bot {
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .el-dialog {
    .head {
      z-index: 103;
      font-size: 18px;
      color: #222;
      height: 53px;
      background: #f2f2f2;
      line-height: 53px;
      position: absolute;
      top: 0;
      left: 0;
      width: 980px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;

      p {
        margin-left: 25px;
        display: inline-block;
      }

      img {
        width: 15px;
        float: right;
        margin-top: 18px;
        margin-right: 24px;
        cursor: pointer;
      }
    }
  }
}

.li {
  background: rgba(0, 0, 0, 0.3);
}
</style>
